export default __webpack_public_path__ + "static/media/wohnungen_intro_web-sm@2x.3cc0cc43.webp";